var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmAndamento(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Solid",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #f7f7f7;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M224,392h16v16h-16v-16Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M128,392h16v16h-16v-16Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256,392h16v16h-16v-16Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M160,392h16v16h-16v-16Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M192,392h16v16h-16v-16Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M440,360H72c-22.09,0-40,17.91-40,40s17.91,40,40,40h368c22.09,0,40-17.91,40-40s-17.91-40-40-40ZM440,424H72c-13.25,0-24-10.75-24-24s10.75-24,24-24h368c13.25,0,24,10.75,24,24s-10.75,24-24,24h0Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M288,392h16v16h-16v-16Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M440,392h-120v16h120c4.42,0,8-3.58,8-8s-3.58-8-8-8Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M64,400c0,4.42,3.58,8,8,8h8v-16h-8c-4.42,0-8,3.58-8,8Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M96,392h16v16h-16v-16Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M289.01,163.88l-33.01-59.41-33.01,59.41c-1.41,2.54-4.09,4.12-6.99,4.12h-46.61l36.68,42.79c1.64,1.91,2.28,4.48,1.74,6.94l-12.14,54.63,56.45-31.36c2.42-1.34,5.35-1.34,7.77,0l56.45,31.36-12.14-54.63c-.55-2.46.1-5.03,1.74-6.94l36.68-42.79h-46.61c-2.91,0-5.58-1.58-6.99-4.12h0Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M141.66,114.34l-24-24c-3.12-3.12-8.19-3.12-11.31,0-3.12,3.12-3.12,8.19,0,11.31l24,24c3.12,3.12,8.19,3.12,11.31,0s3.12-8.19,0-11.31h0Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M130.34,274.34l-24,24c-3.12,3.12-3.12,8.19,0,11.31,3.12,3.12,8.19,3.12,11.31,0l24-24c3.12-3.12,3.12-8.19,0-11.31-3.12-3.12-8.19-3.12-11.31,0h0Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M72,208h32c4.42,0,8-3.58,8-8s-3.58-8-8-8h-32c-4.42,0-8,3.58-8,8s3.58,8,8,8Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M376,128c2.12,0,4.16-.84,5.66-2.34l24-24c3.12-3.12,3.12-8.19,0-11.31-3.12-3.12-8.19-3.12-11.31,0l-24,24c-3.12,3.12-3.13,8.19,0,11.31,1.5,1.5,3.54,2.34,5.66,2.34h0Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M370.34,285.66l24,24c3.12,3.12,8.19,3.12,11.31,0,3.12-3.12,3.12-8.19,0-11.31l-24-24c-3.12-3.12-8.19-3.12-11.31,0-3.12,3.12-3.12,8.19,0,11.31Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M408,192c-4.42,0-8,3.58-8,8s3.58,8,8,8h32c4.42,0,8-3.58,8-8s-3.58-8-8-8h-32Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmAndamento);
export default __webpack_public_path__ + "static/media/em-andamento.9d3d6f3f23b7e6b746b2a4970541f517.svg";
export { ForwardRef as ReactComponent };